import { CommonModule } from '@angular/common';
import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import { FormsModule } from '@angular/forms';
import {
	MatBadgeModule,
	MatButtonModule,
	MatFormFieldModule,
	MatIconModule,
	MatInputModule,
	MatMenuModule,
	MatProgressBarModule,
	MatTabsModule,
	MatTooltipModule,
	MatCardModule,
	MatDividerModule, MatDialog
} from '@angular/material';
import { RouterModule } from '@angular/router';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { LoadingBarModule } from '@ngx-loading-bar/core';
import { TranslateModule } from '@ngx-translate/core';
import { PERFECT_SCROLLBAR_CONFIG, PerfectScrollbarConfigInterface, PerfectScrollbarModule } from 'ngx-perfect-scrollbar';
import { CoreModule } from '../../core/core.module';
import { ListTimelineModule } from '../partials/layout/quick-sidebar/list-timeline/list-timeline.module';
import { AsideLeftComponent } from './aside/aside-left.component';
import { AsideRightComponent } from './aside/aside-right/aside-right.component';
import { MenuSectionComponent } from './aside/menu-section/menu-section.component';
import { FooterComponent } from './footer/footer.component';
import { BrandComponent } from './header/brand/brand.component';
import { HeaderSearchComponent } from './header/header-search/header-search.component';
import { HeaderComponent } from './header/header.component';
import { MenuHorizontalComponent } from './header/menu-horizontal/menu-horizontal.component';
import { AcessoRestritoComponent } from './acesso-restrito/acesso-restrito.component';
import { LanguageSelectorComponent } from './header/topbar/language-selector/language-selector.component';
import { NotificacaoDropdownComponent } from './header/topbar/notificacao-dropdown/notificacao-dropdown.component';
import { NotificationComponent } from './header/topbar/notification/notification.component';
import { QuickActionComponent } from './header/topbar/quick-action/quick-action.component';
import { SearchDefaultComponent } from './header/topbar/search-default/search-default.component';
import { SearchDropdownComponent } from './header/topbar/search-dropdown/search-dropdown.component';
import { TopbarComponent } from './header/topbar/topbar.component';
import { UserProfileComponent } from './header/topbar/user-profile/user-profile.component';
import { SubheaderComponent } from './subheader/subheader.component';
import { MaxNgLibModule } from 'max-ng-lib';
import { NotificacoesComponent } from './header/topbar/notificacoes/notificacoes.component';
import { AutorizacaoDropdownComponent } from './header/topbar/autorizacao-dropdown/autorizacao-dropdown.component';
import {CadastrosModule} from '../pages/components/cadastros/cadastros.module';
import {DialogBannerMaxpagModule} from '../pages/components/cadastros/max-pag/banner-dialog/dialog-banner-maxpag.module';
import {CustomSelectModule} from '../pages/components/shared/components/custom-select/custom-select.module';
import {ListaPaginadaModule} from '../pages/components/shared/components/lista-paginada/lista-paginada.module';
import {ComponentLoaderFactory, PositioningService, TooltipModule} from 'ngx-bootstrap';
import { HeaderUsuarioInfoComponent } from './header/header-usuario-info/header-usuario-info.component';

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
	// suppressScrollX: true
};

@NgModule({
	declarations: [
		HeaderComponent,
		FooterComponent,
		SubheaderComponent,
		BrandComponent,

		// topbar components
		TopbarComponent,
		UserProfileComponent,
		SearchDropdownComponent,
		NotificacaoDropdownComponent,
		NotificationComponent,
		QuickActionComponent,
		LanguageSelectorComponent,
		AutorizacaoDropdownComponent,

		// aside left menu components
		AsideLeftComponent,
		MenuSectionComponent,

		// horizontal menu components
		MenuHorizontalComponent,

		// aside right component
		AsideRightComponent,

		SearchDefaultComponent,

		HeaderSearchComponent,

		AcessoRestritoComponent,

		NotificacoesComponent,

		HeaderUsuarioInfoComponent,

	],
	exports: [
		HeaderComponent,
		FooterComponent,
		SubheaderComponent,
		BrandComponent,

		// topbar components
		TopbarComponent,
		UserProfileComponent,
		SearchDropdownComponent,
		NotificacaoDropdownComponent,
		NotificationComponent,
		QuickActionComponent,
		LanguageSelectorComponent,

		// aside left menu components
		AsideLeftComponent,
		// MenuSectionComponent,

		// horizontal menu components
		MenuHorizontalComponent,

		// aside right component
		AsideRightComponent,
	],
	providers: [
		{
			provide: PERFECT_SCROLLBAR_CONFIG,
			useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG
		},
		ComponentLoaderFactory,
		PositioningService,
	],
    imports: [
        MatDividerModule,
        MatCardModule,
        CommonModule,
        RouterModule,
        CoreModule,
        PerfectScrollbarModule,
        NgbModule,
        FormsModule,
        ListTimelineModule,
        MatProgressBarModule,
        MatTabsModule,
        MatButtonModule,
        MatTooltipModule,
        MatMenuModule,
        MatInputModule,
        MatFormFieldModule,
        TranslateModule.forChild(),
        LoadingBarModule.forRoot(),
        MatIconModule,
        MatBadgeModule,
        MaxNgLibModule,
        DialogBannerMaxpagModule,
        CustomSelectModule,
        ListaPaginadaModule,
		TooltipModule.forRoot()
    ],
	entryComponents: [
		AcessoRestritoComponent
	],
	schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class LayoutModule { }
